import { Box } from "@mui/material";
import dayjs from "dayjs";
import OutlinedCard from "../../../../../../components/OutlineCard";
import ProfileViewer from "../../../../../../components/ProfileViewer";
import Text from "../../../../../../components/Text";
import { GENDER_RECORD } from "../../../../../../constants";
import {
  MARITAL_STATUS,
  RELATIONSHIP_WITH_PATIENT,
} from "../../../../../../constants/provider/add-new-patient";
import { DATE_FORMAT } from "../../../../../../utils/date-time-utility";
import { createMapper } from "../../../../../../utils/utils";

interface PatientBasicDetailsProps {
  values: any;
}

const MARITAL_STATUS_MAPPER = createMapper(MARITAL_STATUS);
const RELATIONSHIP_MAPPER = createMapper(RELATIONSHIP_WITH_PATIENT);

const PatientBasicDetails = ({ values }: PatientBasicDetailsProps) => {
  // Format address as a readable string
  const formatAddress = (address: any) => {
    if (!address) return "";
    const parts = [
      address.line1,
      address.line2,
      address.city,
      address.state,
      address.zipcode,
      address.country,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(", ") : "";
  };

  // Format date
  const formatDate = (date: any) => {
    if (!date) return "";
    try {
      return dayjs(date).format(DATE_FORMAT);
    } catch {
      return "";
    }
  };

  // Prepare data for ProfileViewer
  const profileData: { [key: string]: string } = {
    "First Name": values.firstName || "",
    "Last Name": values.lastName || "",
    "Date of Birth": formatDate(values.birthDate),
    Sex: values.sex ? GENDER_RECORD[values.sex] || values.sex : "",
    "Social Security": values.socialSecurity || "",
    "Mobile Number": values.mobileNumber || "",
    Email: values.email || "",
    Address: formatAddress(values.address),
    "Marital Status": values.maritalStatus
      ? MARITAL_STATUS_MAPPER[values.maritalStatus] || values.maritalStatus
      : "",
    "Spouse Name": values.spouseName || "",
    "Spouse Phone Number": values.spousePhoneNumber || "",
    "Emergency Contact": values.emergencyContact || "",
    "Relationship with Patient": values.relationshipWithPatient
      ? RELATIONSHIP_MAPPER[values.relationshipWithPatient] ||
        values.relationshipWithPatient
      : "",
    "Phone Number": values.phoneNumber || "",
  };

  return (
    <Box mt={0.5} id={"Patient Details"}>
      {/* <Divider textAlign="left" sx={{ mb: 1 }}> */}
      <Text mb={2}>PATIENT DETAILS</Text>
      {/* </Divider> */}
      <OutlinedCard>
        <ProfileViewer data={profileData} withoutColn />
      </OutlinedCard>
    </Box>
  );
};

export default PatientBasicDetails;
